import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
    DetailsBlockWithLoader,
    ExtraInfoBlockWithLoader,
    HeaderBlock,
} from '../../components/RentalCarContract'
import DownloadAppBlock from 'commons/js/components/DownloadAppBlock'
import { FormattedMessage } from 'react-intl'
import { Copy, Button, Box, Icon, Flex, WebviewWrapper } from '@elparking/components'
import { StickyContainer, Sticky } from 'commons/js/ui/Sticky'
import DownloadMobileApp from 'rental-car-contract/js/components/Modals/DownloadMobileApp'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'
import { isWebview } from '@elparking/utils'
import SuccessMessage from 'rental-car-contract/js/components/RentalCarContract/SuccessMessage'

const Content = ({
    id,
    booking,
    user,
    isLoading,
    isMutuaUser,
    request,
    token,
    error,
    onGoToDetail,
}) => {
    const [showDownloadAppModal, setShowDownloadAppModal] = useState(false)

    useEffect(() => {
        token && !error && !isLoading && !booking && request({id, token})
    }, [booking, isLoading, request, token, id, error])

    useEffect(() => {
        (booking && !isLoading) && setTimeout(() =>
            trackTealiumEvent(RentalCarEvents.submitRentalCarBooking), 1000)
    }, [booking, isLoading])

    useEffect(() => {
        (booking && !isLoading) && trackTealiumEvent(RentalCarEvents.showConfirmBookingView)
    }, [booking, isLoading])

    if (!booking || isLoading) {
        return null
    }

    const onShowDownloadAppModal = () => {
        setShowDownloadAppModal(true)
        trackTealiumEvent(RentalCarEvents.showQRConfirmBookingView)
    }

    const onGoToBooking = () => {
        isWebview() ? onGoToDetail(id) : onShowDownloadAppModal()
    }
    return <Box width='100%' padding={['0 1em 1em 1em', '1em']}>
        <DownloadMobileApp
          dataTest='rental-car-download-app-modal'
          isShown={showDownloadAppModal}
          bookingId={id}
          onClose={() => setShowDownloadAppModal(false)}/>
        {!isLoading && user && <HeaderBlock cancelled={booking.cancelled} user={user} />}
        <Flex flexWrap='wrap' justifyContent='space-between' width='100%'>
            {!booking.cancelled && <Box width='100%'>
                <SuccessMessage
                  message={<FormattedMessage
                    defaultMessage='Hemos enviado un email con los detalles a {email}.'
                    values={{email: <Copy as='span' fontWeight='bold'>{user?.email}</Copy>}}
                    />}
                />
                <Button dataTest='go-to-mutua-mas-button' height='auto' padding='1em' width={['100%', 'auto']} onClick={onGoToBooking}>
                    <Flex justifyContent='center'>
                        <Icon type='doc' color='white'/>
                        <Copy fontColor='white' ml='0.5em' padding='0'><FormattedMessage defaultMessage='Ver mi reserva' /></Copy>
                    </Flex>
                </Button>
            </Box>}
            <Box flex={['1 0 100%', '2 0 66%']}>
                <DetailsBlockWithLoader showModal={() => onShowDownloadAppModal()} booking={booking} isLoading={isLoading} token={token}/>
            </Box>
            <Box flex={['1 0 100%', '1 0 100%', '1 0 33%']} padding={['0', '0', '0 0 0 40px']}>
                <StickyContainer>
                    <Sticky top={['0', '10px', '0']} zIndex={2}>
                        {!booking.cancelled && <Box display={['none', 'none', 'block']}>
                            <ExtraInfoBlockWithLoader booking={booking} isMutuaUser={isMutuaUser} isLoading={isLoading} />
                        </Box>}
                        <WebviewWrapper fallbackComponent={<DownloadAppBlock onDownloadApp={() => onShowDownloadAppModal()}/>}><Box/></WebviewWrapper>
                    </Sticky>
                </StickyContainer>
            </Box>
        </Flex>
    </Box>
}

Content.defaultProps = {
    request: () => {},
    onGoToDetail: () => {},
}

Content.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    booking: PropTypes.object,
    user: PropTypes.object,
    isMutuaUser: PropTypes.bool,
    request: PropTypes.func,
    id: PropTypes.number,
    token: PropTypes.string,
    error: PropTypes.any,
    onGoToDetail: PropTypes.func,
}

export default Content
